import styled from 'styled-components'

export const Container = styled.div`  
  position:relative;
  display:flex;
  flex-flow:column noWrap;
  flex:1;
  height:100vh;
  box-sizing: border-box;  
  background-color:tomato;
  justify-content:space-between;
  align-items:center;
  --background-image: url('image/fundoTela01.jpg');
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #1594a5; 
   
`
export const Title = styled.span`
  display:flex;
  flex-flow: row wrap;
  width:100%;
  color: #FFF;
  margin-bottom:4px; 
`
export const ContainerImage = styled.div`
  
  display:flex;  
  top:0px;
  width:100%;
  height:80px;
  justify-content:center;
  align-items:center;  

  @media (min-width: 800px) 
  {
    height:160px;
  } 

  @media (min-width: 700px) 
  {
    height:150px;
  } 
`
export const Image = styled.img`
  width: 40%;

  @media (min-width: 800px) 
  {
    width: 30%;
  } 
`
export const ImageMapa = styled.img`
  width: 70px;
  height: 50px;
  margin: 4px;
`
export const HeaderTitle = styled.span`
  margin-top: 0px;
  font-weight: bold;
  font-size: 26px;
  color: #FFF;
`
export const ContainerField = styled.div`
  margin: 20px 0 20px 0;
  width: 100%;  
`
export const ContainerFieldLocation = styled.div`
  margin-right:20px;
  margin-top: 20px;
  width: 100%;
  display: flex; 
  margin-left: 3px; 
`
export const ContainerIconLocation = styled.div`
  margin-right:20px;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  height: 190px;
  margin-top: 70px;
  padding-right: 30px;
`
export const SubContainerField = styled.div`
  margin-top: -3px;
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;

  span {
    font-size: 12px;
    color: #fff;
  }
`
export const SubContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: row;
  --margin-top: 10px;
  width: 95%;
  z-index: 3;
`
export const ContainerContent = styled.div`
  display:flex;
  flex-flow: row wrap;
  justify-content:center;
  align-items:center;
  width:90%;  
`
export const ContainerButtonMapa = styled.div`
  width: 80px;
  height: 60px;
  flex-direction:row-reverse;
`
export const SubContainerButtonMapa = styled.div`
  background-color:   #40bbca;
  padding: 5px;
  height: 60px;
  width: 78px;
  box-shadow: 10px 10px 20px 0px rgba(0,0,0,0.75);
  border-radius: 19px;
  z-index: 0;
`

export const ContainerBottom = styled.div`
  display: inline-grid;
  width: 100%;
  grid-column-gap: 20px;
  grid-template-columns: 66% 30%;
`

export const ContainerBottomMapButton = styled.div`
  display: flex;
  justify-content: center !important;
  align-items: center;
`